import { render, staticRenderFns } from "./BillEditBadge.vue?vue&type=template&id=25849cbe&scoped=true&"
import script from "./BillEditBadge.vue?vue&type=script&lang=js&"
export * from "./BillEditBadge.vue?vue&type=script&lang=js&"
import style0 from "./BillEditBadge.vue?vue&type=style&index=0&id=25849cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25849cbe",
  null
  
)

export default component.exports